import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddDestinationComponent } from './add-destination/add-destination.component';
import { DestinationsLogComponent } from './destinations-log/destinations-log.component';
import { DestinationsRoutingModule } from './destinations-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgToggleModule } from '@nth-cloud/ng-toggle';



@NgModule({
  declarations: [AddDestinationComponent, DestinationsLogComponent],
  imports: [
    CommonModule,
    SharedModule,
    DestinationsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgToggleModule,
  ]
})
export class DestinationsModule { }
